export function downloadFile(data: string | ArrayBuffer, filename: string, fileContentType: string, isBase64: boolean) {
  let dataToSave: BlobPart;
  if (typeof data === 'string') {
    dataToSave = isBase64 ? base64ToBlobPart(data) : data;
  } else {
    dataToSave = new Uint8Array(data);
  }

  const blob = new Blob([dataToSave], { type: fileContentType || 'application/octet-stream' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function base64ToBlobPart(base64: string): BlobPart {
  const binary_string = window.atob(base64);
  const len = binary_string.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binary_string.charCodeAt(i);
  }
  return bytes;
}
